import { isNullOrUndefined } from "util";
import HtmlParser from "html-react-parser";
import { measurementPreferences } from "./EnumHelpers";
import { round } from "./ConverterHelpers";

export const decodeHtml = (html, removeSurroundingPTags = false) => {
    var content = html;

    if (typeof content !== "string") {
        return '';
    }

    if (removeSurroundingPTags) {
        if (content.toLowerCase().startsWith("&lt;p&gt;")) {
            content = content.substring(9);
        } else if (content.toLowerCase().startsWith("<p>")) {
            content = content.substring(3);
        }

        if (content.toLowerCase().endsWith("&lt;/p&gt;")) {
            content = content.substring(0, content.length - 10);
        } else if (content.toLowerCase().endsWith("</p>")) {
            content = content.substring(0, content.length - 4);
        }
    }

    var txt = document.createElement("textarea");
    txt.innerHTML = content;
    return txt.value;
};

export const replaceContentTokens = (srcText, replaceableTokens) => {
    if (isStringNullUndefinedEmpty(srcText)) {
        return srcText;
    }
    var text = srcText;
    for (var i = 0; i < replaceableTokens.length; i++) {
        var key = replaceableTokens[i]['key'].replace('\[', '\\[').replace('\]', '\\]');
        var regEx = new RegExp(key, "ig");
        text = text.replace(regEx, replaceableTokens[i]['value']);
    }
    return text;
};

export const formatDateWithFullMonth = (d) => {
    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    var date = new Date(d);

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
};

export const formatDateTime = (d, dateSeparator, dateTimeSeparator, timeSeparator, withTime, withMilliseconds) => {
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    var year = d.getFullYear();
    var hour = '' + d.getHours();
    var mins = '' + d.getMinutes();
    var secs = '' + d.getSeconds();
    var millisecs = '' + d.getMilliseconds();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (mins.length < 2) mins = '0' + mins;
    if (secs.length < 2) secs = '0' + secs;
    if (millisecs.length < 2) millisecs = '0' + millisecs;

    var date = '' + year + dateSeparator + month + dateSeparator + day;
    var time = withTime ? '' + dateTimeSeparator + hour + timeSeparator + mins + timeSeparator + secs : '';
    var milliseconds = withMilliseconds ? '' + timeSeparator + millisecs : '';

    return date + time + milliseconds;
};

export const formatDateTimeDMY = (d, dateSeparator, dateTimeSeparator, timeSeparator, withTime, withMilliseconds) => {
    var month = '' + (d.getMonth() + 1);
    var day = '' + d.getDate();
    var year = d.getFullYear();
    var hour = '' + d.getHours();
    var mins = '' + d.getMinutes();
    var secs = '' + d.getSeconds();
    var millisecs = '' + d.getMilliseconds();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    if (hour.length < 2) hour = '0' + hour;
    if (mins.length < 2) mins = '0' + mins;
    if (secs.length < 2) secs = '0' + secs;
    if (millisecs.length < 2) millisecs = '0' + millisecs;

    var date = '' + day + dateSeparator + month + dateSeparator + year;
    var time = withTime ? '' + dateTimeSeparator + hour + timeSeparator + mins + timeSeparator + secs : '';
    var milliseconds = withMilliseconds ? '' + timeSeparator + millisecs : '';

    return date + time + milliseconds;
};

export const formatDateTimeMoment = (d, dateSeparator, dateTimeSeparator, timeSeparator, withTime, withMilliseconds) => {
    var pattern = 'YYYY' + dateSeparator + 'MM' + dateSeparator + 'DD'
        + (withTime ? dateTimeSeparator + 'hh' + timeSeparator + 'mm' + timeSeparator + 'ss' : '')
        + (withMilliseconds ? timeSeparator + 'sss' : '');

    return d.format(pattern);
};

// Usage: sleep(5000).then(() => {});
export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const isStringNullUndefinedEmpty = (string) => {
    if (isNullOrUndefined(string)) {
        return true;
    }

    return string.length === 0;
};


export const apiErrorMessage = (err) => {
    var message = err.message;

    if (!isNullOrUndefined(err.response) && !isNullOrUndefined(err.response.data) && !isNullOrUndefined(err.response.data.Errors) && err.response.data.Errors[0].Message === 'Please choose a nick name without punctuation or special characters.') {
        message = 'Username does not meet the criteria';
    } else if (err.response && err.response.data && err.response.data.Errors && err.response.data.Errors.length > 0 && err.response.data.Errors[0].Message) {
        message = err.response.data.Errors[0].Message;
    }
    else {
        message = isNullOrUndefined(err.response) ? message :
            isNullOrUndefined(err.response.data) ? message :
                typeof (err.response.data) === "string" ? err.response.data :
                    !isNullOrUndefined(err.response.data.Message) ? err.response.data.Message :
                        !isNullOrUndefined(err.response.data.message) ? err.response.data.message :
                            !isStringNullUndefinedEmpty(message) ? message : '';
    }


    return message;
};

export const ConvertSiteUnitOfMeasureToMeasurementPreference = (siteUnitOfMeasure) => {
    switch (siteUnitOfMeasure) {
        case "Imperial":
            return measurementPreferences.Imperial;
        case "Metric":
            return measurementPreferences.Metric;
        default:
            return measurementPreferences.UsStandard;
    }
};

export const scrollToFieldValidationMessage = () => {
    // find all error elements with content in them (empty error div elements exists) and scroll to it
    var element = null;
    $(".invalid-feedback:visible").each(function () {
        var $this = $(this);
        var content = $this.html();
        if (content !== "" && content !== null) {
            element = $this;
            return false;
        }
    });
    var offset = element.closest('.form-group').offset().top;
    setTimeout(function () { $("html, body").animate({ scrollTop: offset - 120 }, 500); }, 500);
};

export const formatDecimalToFractions = (amount) => {
    const whole = Math.floor(amount);
    let decimal = round(amount - whole, 3);
    let fraction = "";

    switch (decimal) {
        case 0.125:
            fraction = "&frac18;";
            decimal = 0;
            break;
        case 0.250:
            fraction = "&frac14;";
            decimal = 0;
            break;
        case 0.330:
        case 0.333:
            fraction = "&frac13;";
            decimal = 0;
            break;
        case 0.500:
            fraction = "&frac12;";
            decimal = 0;
            break;
        case 0.660:
        case 0.666:
        case 0.667:
        case 0.670:
            fraction = "&frac23;";
            decimal = 0;
            break;
        case 0.750:
            fraction = "&frac34;";
            decimal = 0;
            break;
        default:
            fraction = "";
    }
    const number = fraction !== "" ? round(whole + decimal, 1) : round(amount, 1);
    let result = (number > 0 ? number.toString() : "") + (fraction !== "" ? HtmlParser(fraction) + "" : "");
    if (result.endsWith(",")) {
        result = result.replace(/^,+|,+$/g, ""); // IE hack to remove comma (DNA-3228)
    }
    return result;
};

export const formatStringWithFractions = (value) => {
    const parsedValue = parseInt(value);

    //format values less than 1 first
    if (!isNaN(parsedValue) && parsedValue < 1) {
        value = value
            .replace("0.125 ", "&frac18; ")
            .replace("0.25 ", "&frac14; ")
            .replace("0.33 ", "&frac13; ")
            .replace("0.5 ", "&frac12; ")
            .replace("0.66 ", "&frac23; ")
            .replace("0.67 ", "&frac23; ")
            .replace("0.75 ", "&frac34; ")
    };
   
    const valueWithFractions = value
        //.replace("0.125 ", "&frac18; ")
        .replace(".125 ", "&frac18; ")
        //.replace("0.25 ", "&frac14; ")
        .replace(".25 ", "&frac14; ")
        //.replace("0.33 ", "&frac13; ")
        .replace(".33 ", "&frac13; ")
        //.replace("0.5 ", "&frac12; ")
        .replace(".5 ", "&frac12; ")
        //.replace("0.66 ", "&frac23; ")
        .replace(".66 ", "&frac23; ")
        //.replace("0.67 ", "&frac23; ")
        .replace(".67 ", "&frac23; ")
        //.replace("0.75 ", "&frac34; ")
        .replace(".75 ", "&frac34; ");

    let result = HtmlParser(valueWithFractions) + "";
    if (!value.endsWith(",") && result.endsWith(",")) {
        result = result.replace(/^,+|,+$/g, ""); // IE hack to remove comma (DNA-3228)
    }
    return result;
};

export const FormatFoodUnitSubTotals = (foodUnit, showMealReplacementFoodUnits = false) => {
    let result = "";
    if (foodUnit) {
        result += foodUnit.Meat > 0 ? ` ${round(foodUnit.Meat, 1)} Meat & Protein,` : "";
        result += foodUnit.Cereals > 0 ? ` ${round(foodUnit.Cereals, 1)} Bread & Cereals,` : "";
        result += foodUnit.Vegetables > 0 ? ` ${round(foodUnit.Vegetables, 1)} Vegetables,` : "";
        result += foodUnit.Fruit > 0 ? ` ${round(foodUnit.Fruit, 1)} Fruits,` : "";
        result += foodUnit.Dairy > 0 ? ` ${round(foodUnit.Dairy, 1)} Dairy,` : "";
		result += foodUnit.Fats > 0 ? ` ${round(foodUnit.Fats, 1)} Healthy Fats & Oils,` : "";
		//if (showMealReplacementFoodUnits) {
		//	result += foodUnit.MealReplacement > 0 ? ` ${round(foodUnit.MealReplacement, 1)} Meal Replacements,` : "";
  //      }
        result += !isNullOrUndefined(foodUnit.MealReplacement) && foodUnit.MealReplacement > 0 ? ` ${round(foodUnit.MealReplacement, 1)} Meal Replacements,` : "";
        result += foodUnit.Extras > 0 ? ` ${round(foodUnit.Extras, 1)} Indulgences,` : "";
    }
    return result.length > 0 ? result.substring(0, result.length - 1) + " " : null;
};

export const ObjectFromEntries = (iter) => {
    const obj = {};

    for (const pair of iter) {
        if (Object(pair) !== pair) {
            throw new TypeError('iterable for fromEntries should yield objects');
        }

        // Consistency with Map: contract is that entry has "0" and "1" keys, not
        // that it is an array or iterable.

        const { '0': key, '1': val } = pair;

        Object.defineProperty(obj, key, {
            configurable: true,
            enumerable: true,
            writable: true,
            value: val
        });
    }

    return obj;
};

export const FormatCurrency = (val) => {
    return "$" + val.toFixed(2);
};
export const FormatCurrencyWithSymbol = (val,symbol) => {
    return symbol + val.toFixed(2);
};